import React from 'react';
import '../App.css';

export default function RD() {
  return (
    <div className="App">
      <header className="hero">
        <h1 className="hero-title">Research &amp; Development</h1>
        <p className="hero-subtitle">
          A peek into the products and experiments currently in development at RUNIC.
        </p>
      </header>

      <section className="services">
        <h2>Development</h2>
        <div className="service-cards">
          <div className="card">
            <h3>Project Tiempo</h3>
            <p>
              We are building a much needed office management and automation tool for small
              businesses. Allowing for easy scheduling, task analysis, and payroll management.
            </p>
          </div>
          <div className="card">
            <h3>Project Tome</h3>
            <p>
              We are in active development of a Local AI Agent/Research tool. Tome leverages
              expert slms to provide research insights privatly and efficiently.
            </p>
          </div>
          <div className="card">
            <h3>Project Yummers</h3>
            <p>
              We are building a collaborative restaurant decision tool where users create or join a room,
              swipe on nearby restaurant options, and quickly converge on shared top picks.
            </p>
          </div>
        </div>
      </section>

      <section className="services">
        <h2>Research</h2>
        <div className="service-cards">
          <div className="card">
            <h3>Small Language Models: Case Study Review and Recommendations</h3>
            <p>
              This report examines the viability of Small Language Models (SLMs) as efficient,
              accessible alternatives to Large Language Models (LLMs). Its key finding is that
              SLMs can rival larger models, making them ideal for deployment on edge devices.
              This shift offers significant practical benefits, including enhanced data privacy
              compared to LLMs.
            </p>
            <p>
              <a
                href="https://www.nicholaslaureano.com/assets/documents/Small_Language_Models_(SLMs)_A_Case-Study_Review_and_Recommendations.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-button"
                style={{ marginTop: '0.5rem' }}
              >
                View paper
              </a>
            </p>
          </div>
          <div className="card">
            <h3>Seismic Event Classification Neural Network</h3>
            <p><strong>Machine Learning Project &amp; Research Paper</strong></p>
            <p>
              Built a CNN to classify multichannel seismic waveform data using PyTorch.
              Achieved 74.76% overall accuracy and 84.53% binary accuracy (EQ vs. Noise)
              on held-out test data. Conducted hyperparameter tuning with CUDA GPU acceleration.
            </p>
            <p>
              <a
                href="https://github.com/NLaureano/SeismoCNN/blob/master/Seismic_Event_Classification_Using_Convolutional_Neural_Networks_on_Multichannel_Waveform_Data.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-button"
                style={{ marginTop: '0.5rem' }}
              >
                View paper
              </a>
            </p>
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>© 2025 RUNIC Solutions — Building what comes next.</p>
      </footer>
    </div>
  );
}
